<template>
  <div v-if="embedded" class="col-12 refine-search-filter-embedded">
    <RefineSearchMultiCheckbox
      label="Search Make"
      :options="makes"
      v-model="localSelectedMakes"
      :disabled="disabled || isFetchRatebookLoading"
      two-columns-mobile
    />
  </div>
  <CustomExpansionItem v-else class="col-12 q-mb-sm" label="Make" v-model="isOpen">
    <RefineSearchMultiCheckbox
      label="Search Make"
      :options="makes"
      v-model="localSelectedMakes"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </CustomExpansionItem>
</template>

<script>
import CustomExpansionItem from '../CustomExpansionItem';
import RefineSearchMultiCheckbox from './RefineSearchMultiCheckbox';

export default {
  name: 'MakeFilterSection',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    makes: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFetchRatebookLoading: {
      type: Boolean,
      default: false
    },
    /** When true, render only the inner controls (no accordion) for mobile drill-down panels. */
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      localSelectedMakes: { ...this.value },
      isSyncingFromProp: false
    };
  },
  watch: {
    value(newValue) {
      // Prevent circular updates - only sync if different
      if (!this.isSyncingFromProp) {
        this.isSyncingFromProp = true;
        this.localSelectedMakes = { ...newValue };
        this.$nextTick(() => {
          this.isSyncingFromProp = false;
        });
      }
    },
    localSelectedMakes: {
      handler(newValue) {
        // Only emit if change came from user interaction, not prop sync
        if (!this.isSyncingFromProp) {
          this.$emit('input', newValue);
          this.$emit('change');
        }
      },
      deep: true
    }
  },
  components: {
    CustomExpansionItem,
    RefineSearchMultiCheckbox
  }
};
</script>
